import { ready } from '~/core/indexConf';
import createElement from '~/utils/createElement';
import addEvents from '~/utils/addEvents';
import media from '~/utils/media';
import retach from '~/utils/retach';

ready('headerConferences_mobileHeightTrick', '.headerConferences', h => {
	const setVH = () => {
		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	};
	setVH();
	window.addEventListener('resize', setVH);
});

ready('headerConferences_scroll', '.headerConferences', header => {
	const growers = [...header.querySelectorAll('.headerConferences--grow')];

	const do_grow = add => {
		growers.forEach(grow => {
			grow._startH = grow.offsetHeight;
			grow._startW = grow.offsetWidth;
		});
		if (add) header.classList.add('is-collapsed');
		else header.classList.remove('is-collapsed');
		growers.forEach(grow => {
			grow._endH = grow.offsetHeight;
			grow._endW = grow.offsetWidth;
		});
		growers.forEach(grow => {
			grow.animate(
				[
					{
						height: `${grow._startH}px`,
						width: `${grow._startW}px`,
					},
					{
						height: `${grow._endH}px`,
						width: `${grow._endW}px`,
					},
				],
				{
					duration: 375,
					easing: 'ease',
				}
			);
		});
	};

	const do_stick = () => {
		const action = header.querySelector('.headerConferences-action');
		const logo = header.querySelector('.headerConferences-logo');
		const pageWrapDiv = document.querySelector('.pageWrap');
		let height = media.lg.matches ? action.offsetHeight : logo.offsetHeight;
		let top = 0;

		if (window.pageYOffset > 0 && window.pageYOffset < height) {
			top = `-${window.pageYOffset}px`;
			if (header.classList.contains('is-collapsed') && media.lg.matches) do_grow(false);
		} else if (window.pageYOffset >= height) {
			top = `-${height}px`;
			if (!header.classList.contains('is-collapsed') && media.lg.matches) do_grow(true);
		}

		header.style.top = top;
		pageWrapDiv.style.paddingTop = `${header.offsetHeight}px`;
	};

	window.addEventListener('scroll', do_stick);
	do_stick();
});

ready('headerConferences_nav', '.headerConferences', header => {
	const drawer = header.querySelector('.headerConferences-drawer');
	const inner = drawer.querySelector('.headerConferences-drawerInner');
	const nav = header.querySelector('.headerConferences-nav');
	const mobileTriggers = [...header.querySelectorAll('.headerConferences-trigger')];
	const triggers = [...nav.querySelectorAll('.headerConferences-navLabel')];

	const prepare = trigger => {
		const item = trigger.closest('.headerConferences-navItem');
		const list = item.querySelector('.headerConferences-navList');
		const label = item.querySelector('.headerConferences-navLabel');
		if (list) {
			const back = createElement('li', { class: 'headerConferences-navBack' }, label.textContent);
			list.insertAdjacentElement('afterbegin', back);
			addEvents(back, 'click.self', close);
			addEvents(trigger, 'click.prevent', toggle);
		}
	};
	const toggle = function(e) {
		const item = this.closest('.headerConferences-navItem');
		const list = item.querySelector('.headerConferences-navList');
		const sibs = [...header.querySelectorAll('.headerConferences-navItem')].filter(s => s !== item);
		sibs.forEach(s => s.classList.remove('is-active'));
		item.classList.toggle('is-active');
		inner.classList.toggle('is-locked');
		list.scrollTop = 0;
		inner.scrollTop = 0;
	};
	const close = function() {
		const item = this.closest('.headerConferences-navItem');
		const list = item.querySelector('.headerConferences-navList');
		item.classList.remove('is-active');
		inner.classList.remove('is-locked');
		list.scrollTop = 0;
		inner.scrollTop = 0;
	};

	triggers.forEach(trigger => prepare(trigger));
	addEvents(mobileTriggers, 'click', () => header.classList.toggle('is-open'));
	//commented out for nug. add back in and fix after pres
	// addEvents(drawer, 'click.self', () => header.classList.remove('is-open'))
	addEvents(document, 'click', e => {
		let isNav = e.target.closest('.headerConferences-nav');
		if (!isNav) {
			let item = nav.querySelector('.is-active');
			item ? close.apply(item) : false;
		}
	});
});

ready('headerConferences_retach', '.headerConferences', header => {
	const drawer = header.querySelector('.headerConferences-drawerInner');
	const nav = header.querySelector('.headerConferences-nav');
	const action = header.querySelector('.headerConferences-action');
	const util = header.querySelector('.headerConferences-util');

	const do_stick = () => {
		const action = header.querySelector('.headerConferences-action');
		const logo = header.querySelector('.headerConferences-logo');
		const pageWrapDiv = document.querySelector('.pageWrap');
		let height = media.lg.matches ? action.offsetHeight : logo.offsetHeight;
		let top = 0;

		if (window.pageYOffset > 0 && window.pageYOffset < height) {
			top = `-${window.pageYOffset}px`;
			if (header.classList.contains('is-collapsed') && media.lg.matches) do_grow(false);
		} else if (window.pageYOffset >= height) {
			top = `-${height}px`;
			if (!header.classList.contains('is-collapsed') && media.lg.matches) do_grow(true);
		}

		header.style.top = top;
		setTimeout(() => {
			pageWrapDiv.style.paddingTop = `${header.offsetHeight}px`;
		}, 150);
	};

	retach(nav, {
		destination: drawer,
		mediaQuery: 991,
		callback_move() {
			do_stick();
		},
		callback_back() {
			do_stick();
		},
	});
	retach(action, {
		destination: drawer,
		mediaQuery: 991,
		callback_move() {
			do_stick();
		},
		callback_back() {
			do_stick();
		},
	});
	retach(util, {
		destination: drawer,
		mediaQuery: 991,
		callback_move() {
			do_stick();
		},
		callback_back() {
			do_stick();
		},
	});
});
